/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdaytue3Inputs */

const en_placewebdaytue3 = /** @type {(inputs: Placewebdaytue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tue`)
};

const de_placewebdaytue3 = /** @type {(inputs: Placewebdaytue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di`)
};

/**
* | output |
* | --- |
* | "Tue" |
*
* @param {Placewebdaytue3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdaytue3 = /** @type {((inputs?: Placewebdaytue3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdaytue3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdaytue3(inputs)
	return de_placewebdaytue3(inputs)
});
export { placewebdaytue3 as "placeWebDayTue" }